import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button } from '@nextiva/next-ui';

import { formatter } from 'utils';

import './PaymentDrawerFooter.scss';

export const blockName = 'payment-drawer-footer';

const PaymentDrawerFooter = ({
  amount,
  callVantivRegistration,
  close,
  isSummaryPage,
  submitButtonDisabled,
}) => (
  <div
    data-testid={blockName}
    className={`${blockName} ${blockName}--big-top-space`}
  >
    <Button
      className={`${blockName}__button ${blockName}--right-margin`}
      onClick={close}
    >
      Cancel
    </Button>
    <Button
      className={clsx(
        `${blockName}__button`,
        isSummaryPage && `${blockName}--big-button`
      )}
      kind="primary"
      onClick={callVantivRegistration}
      disabled={!window.eprotectIframeClient || submitButtonDisabled}
    >
      {isSummaryPage ? `Pay Now: ${formatter.format(amount)}` : 'Create'}
    </Button>
  </div>
);

PaymentDrawerFooter.defaultProps = {
  amount: '',
};

PaymentDrawerFooter.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  callVantivRegistration: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  isSummaryPage: PropTypes.bool.isRequired,
  submitButtonDisabled: PropTypes.bool.isRequired,
};

export default PaymentDrawerFooter;
